import { cmToPxRatio, currentBrick } from './globals';

export const cmToPx = (pixel, showUnit = false) => {
  return pixel * cmToPxRatio + (showUnit ? 'px' : 0);
};

export const pxToCm = (cm) => {
  return cm / cmToPxRatio;
};

export const heightInCm = (brickCountVertically) => {
  return brickCountVertically * currentBrick.halfBrick.height;
};

export const widthInCm = (brickCountHorizontally) => {
  return brickCountHorizontally * currentBrick.halfBrick.width;
};

export const heightInBrick = (height) => {
  return height / currentBrick.halfBrick.height;
};

export const widthInBrick = (width) => {
  return width / currentBrick.halfBrick.width;
};

export const even = (number) => number % 2 === 0;

export const odd = (number) => number % 2 === 1;

export const getItemIndexById = (elements, id) => {
  let foundIndex = elements.findIndex((element) => element.id === id);

  return foundIndex > -1 ? foundIndex : 0;
};

export const getItemById = (elements, id) => {
  return elements.find((element) => element.id === id);
};

export const getCurrentGroup = (state, groupId = null) => {
  const currentGroupIndex = getItemIndexById(state.groups, groupId ? groupId : state.currentGroupId);

  return state.groups[currentGroupIndex];
};

export const getLargestId = (items) => {
  let largestId = 0;

  for (const item of items) {
    if (item.id > largestId) {
      largestId = item.id;
    }
  }

  return largestId;
};
